import { css } from 'linaria';

export const TooltipProfileClassName = css`
  & [role='tooltip'] {
    padding: var(--space-100) 0;
    transition: unset;
    pointer-events: unset;
  }
`;
